// extracted by mini-css-extract-plugin
export var challenge = "Card-module--challenge--6d9b3";
export var date = "Card-module--date--cfeba";
export var description = "Card-module--description--f5e9c";
export var icon = "Card-module--icon--562a2";
export var image = "Card-module--image--ca0a6";
export var left = "Card-module--left--6d4bd";
export var picture = "Card-module--picture--c3b84";
export var right = "Card-module--right--61f28";
export var root = "Card-module--root--55374";
export var thumb = "Card-module--thumb--87ae0";
export var title = "Card-module--title--fc11a";
export var titleContainer = "Card-module--titleContainer--67bba";